let mobileSignMode = [
  'MS_SIGN',
  'MS_TIMESTAMP'
]

export default mobileSignMode
